import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

const listaAmbiente = [
  { value: 1, label: 'PRODUÇÃO' },
  { value: 2, label: 'HOMOLOGAÇÃO' }
];
const listaModelo = [
  { value: 65, label: 'NFCE' },
  { value: 55, label: 'NFE' }
];
const listaCRT = [
  { value: 1, label: 'SIMPLES NACIONAL' },
  { value: 2, label: 'SIMPLES NACIONAL, EXCESSO SUBLIMITE DA RECEITA BRUTA' },
  { value: 3, label: 'REGIME NORMAL' },
  { value: 4, label: 'SIMPLES NACIONAL - MICROEMPREENDEDOR INDIVIDUAL - MEI' }
];
const listaIndPres = [
  { value: 0, label: 'NÃO SE APLICA' },
  { value: 1, label: 'OPERAÇÃO PRESENCIAL' },
  { value: 2, label: 'NÃO PRESENCIAL, INTERNET' },
  { value: 3, label: 'NÃO PRESENCIAL, TELEATENDIMENTO' },
  { value: 4, label: 'NFCE ENTREGA EM DOMICÍLIO' },
  { value: 5, label: 'OPERAÇÃO PRESENCIAL, FORA DO ESTABELECIMENTO' },
  { value: 9, label: 'NÃO PRESENCIAL, OUTROS' }
];
const listaTpEmis = [
  { value: 1, label: 'NORMAL' },
  { value: 2, label: 'CONTINGÊNCIA FS' },
  { value: 3, label: 'REGIME ESPECIAL NFF' },
  { value: 4, label: 'CONTINGÊNCIA DPEC' },
  { value: 5, label: 'CONTINGÊNCIA FSDA' },
  { value: 6, label: 'CONTINGÊNCIA SVC- AN' },
  { value: 7, label: 'CONTINGÊNCIA SVC - RS' },
  { value: 9, label: 'CONTINGÊNCIA OFF-LINE NFC-E' }
];

function ConfiguracaoNfcePage({ empresa, usuario, onVoltar, onSair }) {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({
    id: null,
    ambiente: '',
    mod: '',
    referencia: '',
    serie: '',
    crt: '',
    indpres: '',
    tpemis: '',
    dhcont: '',
    xjust: ''
  });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });

  const fetchConfigs = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/nf_config?empresa_id=${empresa.id}`);
      const data = await res.json();
      setConfigs(Array.isArray(data) ? data : []);
    } catch (err) {
      setErro('Erro ao buscar configurações');
      setConfigs([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchConfigs();
    // eslint-disable-next-line
  }, [empresa.id]);

  const abrirModal = (config = null) => {
    if (config) {
      setForm({
        id: config.id,
        ambiente: config.ambiente,
        mod: config.mod,
        referencia: config.referencia,
        serie: config.serie,
        crt: config.crt,
        indpres: config.indpres,
        tpemis: config.tpemis,
        dhcont: config.dhcont ? config.dhcont.slice(0, 16) : '',
        xjust: config.xjust || ''
      });
      setEditando(true);
    } else {
      setForm({
        id: null,
        ambiente: '',
        mod: '',
        referencia: '',
        serie: '',
        crt: '',
        indpres: '',
        tpemis: '',
        dhcont: '',
        xjust: ''
      });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({
      id: null,
      ambiente: '',
      mod: '',
      referencia: '',
      serie: '',
      crt: '',
      indpres: '',
      tpemis: '',
      dhcont: '',
      xjust: ''
    });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (
      form.ambiente === '' ||
      form.mod === '' ||
      form.referencia === '' ||
      form.serie === '' ||
      form.crt === '' ||
      form.indpres === '' ||
      form.tpemis === ''
    ) {
      setErro('Preencha todos os campos obrigatórios!');
      return;
    }
    try {
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/nf_config/${form.id}` : `${API_URL}/nf_config`;
      const body = {
        empresa_id: empresa.id,
        ambiente: form.ambiente === '' ? null : Number(form.ambiente),
        mod: form.mod === '' ? null : Number(form.mod),
        referencia: form.referencia === '' ? null : Number(form.referencia),
        serie: form.serie === '' ? null : Number(form.serie),
        crt: form.crt === '' ? null : Number(form.crt),
        indpres: form.indpres === '' ? null : Number(form.indpres),
        tpemis: form.tpemis === '' ? null : Number(form.tpemis),
        dhcont: form.dhcont ? new Date(form.dhcont).toISOString() : null,
        xjust: form.xjust
      };
      // Log para depuração
      console.log('Enviando body para /nf_config:', body);
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) {
        const erroApi = await res.json().catch(() => ({}));
        setErro(erroApi.error || 'Erro ao salvar configuração');
        return;
      }
      fecharModal();
      fetchConfigs();
    } catch (err) {
      setErro('Erro ao salvar configuração');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/nf_config/${confirmarExclusao.id}`, { method: 'DELETE' });
      fetchConfigs();
    } catch {
      setErro('Erro ao remover configuração');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa local igual UnidadesPage
  const configsFiltradas = configs.filter(c =>
    String(c.serie).toLowerCase().includes(pesquisa.toLowerCase()) ||
    String(c.referencia).toLowerCase().includes(pesquisa.toLowerCase()) ||
    String(c.xjust || '').toLowerCase().includes(pesquisa.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Configuração NFC-e/NF-e</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por série, número ou justificativa..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {configsFiltradas.map(c => (
              <div key={c.id} className="bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-blue-800 text-lg">Série: {c.serie}</span>
                  <div className="flex space-x-2">
                    <button onClick={() => abrirModal(c)} title="Editar" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                    </button>
                    <button onClick={() => handleDelete(c.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                  </div>
                </div>
                <div className="text-gray-700 mb-1"><b>Ambiente:</b> {listaAmbiente.find(a => a.value === c.ambiente)?.label}</div>
                <div className="text-gray-700 mb-1"><b>Modelo:</b> {listaModelo.find(m => m.value === c.mod)?.label}</div>
                <div className="text-gray-700 mb-1"><b>Número:</b> {c.referencia}</div>
                <div className="text-gray-700 mb-1"><b>Série:</b> {c.serie}</div>
                <div className="text-gray-700 mb-1"><b>CRT:</b> {listaCRT.find(crt => crt.value === c.crt)?.label}</div>
                <div className="text-gray-700 mb-1"><b>Ind. Presença:</b> {listaIndPres.find(i => i.value === c.indpres)?.label}</div>
                <div className="text-gray-700 mb-1"><b>Tipo Emissão:</b> {listaTpEmis.find(t => t.value === c.tpemis)?.label}</div>
                <div className="text-gray-700 mb-1"><b>Data Contingência:</b> {c.dhcont ? new Date(c.dhcont).toLocaleString('pt-BR') : '-'}</div>
                <div className="flex justify-between items-center text-gray-700 mb-1">
                  <span><b>Justificativa:</b> {c.xjust || '-'}</span>
                  <span className="text-xs text-gray-500 font-bold">ID: {c.id}</span>
                </div>
              </div>
            ))}
            {configsFiltradas.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhuma configuração encontrada.</div>
            )}
          </div>
        )}
        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Configuração"
        >
          +
        </button>
        {/* Modal */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-2xl relative">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Configuração' : 'Nova Configuração'}</h3>
              <form onSubmit={handleSubmit} className="space-y-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Ambiente*</label>
                    <select name="ambiente" value={form.ambiente} onChange={handleChange} className="border rounded px-3 py-2 w-full" required>
                      <option value="">Selecione...</option>
                      {listaAmbiente.map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Modelo*</label>
                    <select name="mod" value={form.mod} onChange={handleChange} className="border rounded px-3 py-2 w-full" required>
                      <option value="">Selecione...</option>
                      {listaModelo.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Número*</label>
                    <input name="referencia" type="number" value={form.referencia} onChange={handleChange} className="border rounded px-3 py-2 w-full" required />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Série*</label>
                    <input name="serie" type="number" value={form.serie} onChange={handleChange} className="border rounded px-3 py-2 w-full" required />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">CRT*</label>
                    <select name="crt" value={form.crt} onChange={handleChange} className="border rounded px-3 py-2 w-full" required>
                      <option value="">Selecione...</option>
                      {listaCRT.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Indicador Presença*</label>
                    <select name="indpres" value={form.indpres} onChange={handleChange} className="border rounded px-3 py-2 w-full" required>
                      <option value="">Selecione...</option>
                      {listaIndPres.map(i => <option key={i.value} value={i.value}>{i.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Tipo Emissão*</label>
                    <select name="tpemis" value={form.tpemis} onChange={handleChange} className="border rounded px-3 py-2 w-full" required>
                      <option value="">Selecione...</option>
                      {listaTpEmis.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Data Contingência</label>
                    <input name="dhcont" type="datetime-local" value={form.dhcont} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Justificativa</label>
                    <input name="xjust" maxLength={100} value={form.xjust} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                  </div>
                </div>
                {erro && <div className="text-red-600 mb-2">{erro}</div>}
                <div className="flex justify-end space-x-2 mt-4">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">{editando ? 'Salvar' : 'Cadastrar'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-sm relative">
              <h3 className="text-lg font-bold mb-4">Confirmar exclusão?</h3>
              <div className="flex justify-end gap-2 mt-6">
                <button onClick={cancelarRemocao} className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300">Cancelar</button>
                <button onClick={confirmarRemocao} className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700">Excluir</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ConfiguracaoNfcePage; 